import styled from 'styled-components'
import { theme, Input } from '@/client/components'
const { color, space } = theme

export const Search = styled(Input)`
  margin-bottom: ${space.xl3};
`

export const SearchIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  padding: 0 ${space.sm};
  height: ${space.xl3};
  color: ${color.grayscale.black};

  &:hover {
    color: ${color.primary.pure};
  }
`
